import * as actions from '@/modules/bankAccounts'

export const fetchBankAccounts = async ({ dispatch, rootGetters }) => {
  if (rootGetters['fetching/isFetching']('bankAccounts')) {
    return await rootGetters['fetching/getRequest']('bankAccounts');
  }

  const request = actions.fetchBankAccounts();

  const response = await dispatch('fetching/doRequest', { id: 'bankAccounts', request }, { root: true })

  response.data.forEach(data => dispatch('upsertBankAccount', data))

  return response;
}

export const fetchBankAccount = async ({ dispatch, rootGetters }, id) => {

  if (rootGetters['fetching/isFetching'](id)) {
    return await rootGetters['fetching/getRequest'](id);
  }

  const request = actions.fetchBankAccount(id);

  const response = await dispatch('fetching/doRequest', { id, request }, { root: true })

  dispatch('upsertBankAccount', response.data)

  return response;
}

export const upsertBankAccount = async ({ commit }, data) => {

  const { ...bankAccount } = data;

  commit('upsertOne', bankAccount)
}

export default {
  fetchBankAccounts,
  fetchBankAccount,
  upsertBankAccount
}
